var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bs-col',{staticClass:"ui-toolbar-item",class:{right:_vm.right},attrs:{"col-auto":_vm.auto},on:{"click":_vm.click}},[_vm._t("default",[_c('span',{class:_vm.icon,style:({color:_vm.color})})])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7552af86","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-toolbar/src/ui-toolbar-item.vue
// module id = 726
// module chunks = 0